/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SectionPermission,
    SectionPermissionFromJSON,
    SectionPermissionFromJSONTyped,
    SectionPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SectionPermissionIdAndLabel
 */
export interface SectionPermissionIdAndLabel {
    /**
     * 
     * @type {SectionPermission}
     * @memberof SectionPermissionIdAndLabel
     */
    id?: SectionPermission;
    /**
     * 
     * @type {string}
     * @memberof SectionPermissionIdAndLabel
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SectionPermissionIdAndLabel
     */
    effective?: boolean;
}

export function SectionPermissionIdAndLabelFromJSON(json: any): SectionPermissionIdAndLabel {
    return SectionPermissionIdAndLabelFromJSONTyped(json, false);
}

export function SectionPermissionIdAndLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionPermissionIdAndLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : SectionPermissionFromJSON(json['id']),
        'label': !exists(json, 'label') ? undefined : json['label'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
    };
}

export function SectionPermissionIdAndLabelToJSON(value?: SectionPermissionIdAndLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': SectionPermissionToJSON(value.id),
        'label': value.label,
        'effective': value.effective,
    };
}


